import type { CategoryConfig } from "./category";

export function normalizeCategoryConfig(raw: CategoryConfig): CategoryConfig {
  return {
    ...raw,
    iconType: raw.iconType ?? "antd",
    color: raw.color ?? "#1890ff",
    quickQa: raw.quickQa ?? [],
    questionTree: raw.questionTree ?? [],
  };
}
